import type { ComponentProps } from 'react';

import { cn } from '@crm/shared/lib';
import { Checkbox, TableHead } from '@crm/shared/ui';

import { DealTableCell } from '../DealTableCell';

type DealCheckboxCellProps = ComponentProps<typeof Checkbox> & {
    'aria-label': string;
    variant?: 'body' | 'header';
};

export const DealCheckboxCell = ({
    className,
    variant = 'body',
    ...checkboxProps
}: DealCheckboxCellProps) => {
    const checkbox = (
        <label className="absolute inset-0 flex cursor-pointer items-center px-1">
            <Checkbox
                className={cn(
                    'cursor-pointer after:inset-0',
                    variant === 'body' && 'border-smtr-main-accent-100',
                    className
                )}
                {...checkboxProps}
            />
        </label>
    );

    if (variant === 'header') {
        return (
            <TableHead className="relative self-stretch px-1" data-row-navigation="ignore">
                {checkbox}
            </TableHead>
        );
    }

    return (
        <DealTableCell className="relative self-stretch px-1" data-row-navigation="ignore">
            {checkbox}
        </DealTableCell>
    );
};
